import { PIN_USER, UNPIN_USER } from './actionTypes';
export function pinUser(participantId) {
    return {
        type: PIN_USER,
        participantId
    };
}
export function unpinUser(participantId) {
    return {
        type: UNPIN_USER,
        participantId
    };
}
